(function () {
  'use strict';

  angular.module('sempraWebapp').component('operatingTimeVacuum', {
    templateUrl:
      'app/facilityKarcherDetails/operatingTimeVacuum/operatingTimeVacuum.html',
    controller: operatingTimeVacuum,
    bindings: {
      operatingTimeVacuumList: '<',
      activation: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function operatingTimeVacuum(
    sortArrayService,
    helperService,
    $log,
    $mdDialog,
    karcherOperatingTimeDaysMapper
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if (
        changes.operatingTimeVacuumList &&
        changes.operatingTimeVacuumList.currentValue
      ) {
        vm.operatingTimeVacuumList = sortArrayService.sortByGroupValue(
          karcherOperatingTimeDaysMapper.getDays(
            changes.operatingTimeVacuumList.currentValue
          )
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateOperationVacuumTime = function (ev, data) {
      if (!data) {
        return;
      }
      $mdDialog
        .show({
          controller: 'ActuateOperationTimeVacuumController',
          controllerAs: 'vm',
          templateUrl:
            'app/karcherCustomDialogs/actuateOperationTimeVacuum/actuateOperationTimeVacuum.html',
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: data },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data.actuators, parentPointId: data.id });
          },
          function () {}
        );
    };
  }
})();
